module.exports = __webpack_public_path__ + "static/media/profileMale.187d9612.svg";